function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "#FFF",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M.8222 8.1247l.0065.0065-.768 2.6925c-.236.8263.236 1.318 1.082 1.082l2.6787-.7818.0054.0054 5.8701-5.87-3.0045-3.0047L.8222 8.1247zM11.6168 1.677L10.2791.3395c-.4524-.4525-1.2-.4525-1.6721 0L7.4857 1.4607l3.0098 3.0098 1.1213-1.1213c.4722-.4721.4722-1.2197 0-1.6721"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 12
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/SmallPencil.66257686.svg";
export { SvgComponent as ReactComponent };